import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            title: '',
            programId: 0,
            companies: [],
            groups: [],
            selectedGroup: '',
            currentDate: new Date(),
            currentWeek: '',
            selectedDate: "",
            week: [],
            enableFuture: -2,
            showPlayVideo: false,
            hideTitle: false,
            showBackButton: true,
            itemToShow: null,
            startDate: '',
            endDate: '',
            showType: "DAY",
            isLoading: true,
            dynamicColors: {},
            defaultBgColor: 'FF1C242D'
        }
    },
    methods: {
        displayMonth: displayMonth,
        updateCollapsed: updateCollapsed,
        isWithinXMonthsAhead: isWithinXMonthsAhead,
        getStartOfWeek: getStartOfWeek,
        isEnableFuture: isEnableFuture,
        formatDate: formatDate,
        changeMonth: changeMonth,
        getMonthDisplay: getMonthDisplay,
        displayWeek: displayWeek,
        getStartOfMonth: getStartOfMonth,
        getEndOfMonth: getEndOfMonth,
        deleteTrainingOfTheDay: deleteTrainingOfTheDay,
        getTrainingOfTheDayForPeriod: getTrainingOfTheDayForPeriod,
        getAllTrainingsForProgram: getAllTrainingsForProgram,
        playVideo: playVideo,
        hasVideoOrImage: hasVideoOrImage,
        changeWeek: changeWeek,
        getDayFromDate: getDayFromDate,
        getName: getName,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        getPageBgStyle: getPageBgStyle,
        saveResults: saveResults,
        saveImageResults: saveImageResults,
        uploadImageBeforeSaveResults: uploadImageBeforeSaveResults,
        getTrainingResultsForTrainingOfTheDays: getTrainingResultsForTrainingOfTheDays,
        isAllResultSet: isAllResultSet,
        goBack() {
            this.$router.push('/personal-list-program-user?' +
                '?showType='+ this.showType +
                '&enableFuture='+ this.enableFuture +
                '&hideTitle='+ this.hideTitle +
                '&showBackButton='+ this.showBackButton +
                '&programToken='+this.programToken)
            // this.$router.back();
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        openDatePicker() {
            const input = this.$refs.dateInput;
            if (input) {
                if(this.isMobile()){
                    input.click();
                    console.log(input);
                }else{
                    input.showPicker();
                    console.log(input);
                }
            }
        },
        openChooser(id) {
            this.$refs["fileInput_" + id][0].click(); // jer je ref u v-for nizu
        },
        onFileSelected(e, item) {
            // const file = event.target.files[0];
            // if (file) {
            //     console.log("Za item:", item.id, "izabrana slika:", file);
            //     // ovde radiš upload ili preview
            //     item.choosedImage = file
            // }

            const file = e.target.files && e.target.files[0];
            if (!file) return;

            if (file.size > 5000000) {
                alert(this.locale.t('label_max_size_picture'))
                return
            }

            // Očisti stari URL ako postoji
            if (item.choosedImagePreview) {
                URL.revokeObjectURL(item.choosedImagePreview);
            }

            // Brz preview preko ObjectURL
            item.choosedImagePreview = URL.createObjectURL(file);
            item.choosedImage = file;
            const reader = new FileReader();
            reader.onload = e => {}
            reader.readAsDataURL(file);
        },
        removeImage(item) {
            if (item.choosedImagePreview) {
                URL.revokeObjectURL(item.choosedImagePreview);
            }
            item.choosedImagePreview = null;
            item.choosedImage = null;

            // opciono: očisti i vrednost <input>-a da bi isti fajl mogao ponovo da se izabere
            const refArr = this.$refs['fileInput_' + item.id];
            const el = Array.isArray(refArr) ? refArr[0] : refArr;
            if (el) el.value = '';
        },
        removeUserImage(item){
            item.results[0].userImage = null
        }
    },

    created() {

        this.$topnavbar.$on('closePlayVideo', () => {
            this.showPlayVideo = false
            this.itemToShow = null
        });


    },

    beforeMount() {
        // if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
        //     this.$router.push(CONFIG_COMPANY.HOME);
        //     return;
        // }
        this.role = session.getRole();
        this.programId = this.$route.query.id;
        this.title = this.$route.query.name;
        if(this.$route.query.showType != null){
            this.showType = this.$route.query.showType;
        }
        if(this.$route.query.enableFuture != null){
            this.enableFuture = parseInt(this.$route.query.enableFuture, 10);
        }

        if(this.$route.query.hideTitle != null){
            this.hideTitle = this.$route.query.hideTitle === 'true';
        }

        if(this.$route.query.showBackButton != null){
            this.showBackButton = this.$route.query.showBackButton === 'true';
        }
        if(this.showType === "ALL"){
            this.getAllTrainingsForProgram();
        }else{
            this.displayWeek();
        }
        this.dynamicColors = session.getAppColors() || {};
    },

    computed: {
        filteredTrainings() {
            if(this.week.length === 0) return [];
            if(this.selectedGroup == null) return this.week[0].details
            if(this.selectedGroup === LocService.t('label_pt_other_category')){
                return this.week[0].details.filter(i => i.category == null || i.category.length === 0)
            }
            return this.week[0].details.filter(i => i.category === this.selectedGroup)
        }
    },

    watch: {
        'selectedDate': function (newVal) {
            if(newVal != null){
                this.currentWeek = this.$moment(new Date(newVal)).format('DD-MM-YYYY');
                this.currentDate = new Date(newVal);
                this.displayWeek();
            }
        }
    }
}

function hasVideoOrImage(detailsItem){
    return (detailsItem.imageUrl != null && detailsItem.imageUrl.length > 0) || (detailsItem.videoUrl != null && detailsItem.videoUrl.length > 0)
}

function resolveBgColor(raw, fallback){
    if(raw == null) return fallback;
    let value = ('' + raw).trim();
    if(value.length === 0) return fallback;
    if(value[0] === '#') value = value.substring(1);

    // Backend often sends AARRGGBB; convert to RRGGBB for CSS.
    if(value.length === 8){
        value = value.substring(2);
    }

    if(value.length !== 6 && value.length !== 3) return fallback;
    return '#' + value;
}

function getPageBgStyle(){
    const bgRaw = this.dynamicColors != null && this.dynamicColors.BG != null ? this.dynamicColors.BG : this.defaultBgColor;
    return {
        '--personal-page-bg': resolveBgColor(bgRaw, '#1C242D')
    };
}

function playVideo(item){
    for(var i = 0; i < this.week.length; i++){
        for(var j = 0; j < this.week[i].details.length; j++){
            this.week[i].details[j].playingVideo = null;
        }
    }
    item.playingVideo = item.videoUrl;
    return;
    this.itemToShow = item;
    this.showPlayVideo = true;
}

function getStartOfWeek(date) {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when day is Sunday
    return new Date(date.setDate(diff));
}

function getStartOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function getEndOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

// Funkcija za formatiranje datuma
function formatDate(date) {
    return this.$moment(date).format('DD-MM-YYYY')
    // return date.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    // });
}


// Funkcija za prikaz trenutne nedelje u kontejnerima
function displayWeek() {
    if(this.showType === "MONTH"){
        this.displayMonth();
        return;
    }
    const startOfWeek = this.currentDate;//getStartOfWeek(new Date(this.currentDate));
    this.week = [];
    for (let i = 0; i < 1; i++) {
        const currentDay = new Date(startOfWeek);
        currentDay.setDate(startOfWeek.getDate() + i);
        this.week.push({
            date: this.formatDate(currentDay),
            details: []
        })
        // weekContainer.children[i].textContent = formatDate(currentDay);
    }

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 1);
    this.startDate = this.formatDate(startOfWeek);
    this.endDate = this.formatDate(startOfWeek);
    this.currentWeek = ` ${this.startDate}`;
    this.getTrainingOfTheDayForPeriod();
}

function displayMonth(){
    const startOfMonth = this.getStartOfMonth(new Date(this.currentDate))
    const endOfMonth = this.getEndOfMonth(new Date(this.currentDate))
    this.week.push({
        id: 0,
        date: 'oktobar',
        details: []
    })
    this.startDate = this.formatDate(startOfMonth);
    this.endDate = this.formatDate(endOfMonth);
    this.currentWeek = ` ${this.getMonthDisplay( (new Date(this.currentDate)).getMonth() + 1)}`;
    this.getTrainingOfTheDayForPeriod();
}

// Funkcija za promenu nedelje
function changeWeek(offset) {
    if(offset > 0){ if(!this.isEnableFuture()) return; }
    console.log("OVDE SAM");
    this.week = [];
    if(this.showType === 'MONTH'){
        this.changeMonth(offset);
        return;
    }

    this.currentDate.setDate(this.currentDate.getDate() + offset);
    this.displayWeek();
}

function changeMonth(offset){
    this.week = [];
    this.currentDate.setMonth(this.currentDate.getMonth() + offset);
    this.displayMonth();
}

function getAllTrainingsForProgram(){
    const startOfWeek = this.currentDate;
    let _self = this;
    this.startDate = this.formatDate(startOfWeek);
    this.endDate = this.formatDate(startOfWeek);
    this.week.push({
        id: 0,
        date: 'oktobar',
        details: []
    })
    let model = {
        fromDate: this.startDate,
        toDate: this.endDate,
        type: "PERSONAL",
        programId: this.programId,
        allTrainings: true
    }

    AdminApiService.getUserTrainingOfTheDayForPeriod(model)
        .then((response) => {
            this.week.forEach(w => {w.details = [];})
            _self.groups = [];
            var shouldAddOther = false;
            response.data.forEach(dateObj => {
                dateObj.playingVideo = null;
                dateObj.showFullText = false;
                dateObj.collapsed = false;
                dateObj.results = [];
                dateObj.choosedImage = null;
                dateObj.choosedImagePreview = null;
                if(dateObj.resultRounds != null && dateObj.resultRounds > 0){
                    for (var i = 0; i < dateObj.resultRounds; i++){
                        dateObj.results.push({
                            index: (i + 1),
                            id: null,
                            quantity: null,
                            weight: null
                        })
                    }
                }
                dateObj.isLoadingResults = dateObj.resultRounds != null || dateObj.resultMeasure;
                if(!_self.groups.includes(dateObj.category)){
                    if(dateObj.category == null || dateObj.category.length === 0){
                        shouldAddOther = true;
                    }else{
                        _self.groups.push(dateObj.category)
                    }

                }
                const item = this.week.find(entry => entry.id === 0);
                if (item) {
                    item.details.push(dateObj);
                }
            });
            if(shouldAddOther){
                _self.groups.push(LocService.t('label_pt_other_category'))
            }

            if(_self.groups.length > 0){
                _self.selectedGroup = _self.groups[0]
            }
            _self.isLoading = false;
            _self.getTrainingResultsForTrainingOfTheDays(response.data)
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingOfTheDayForPeriod(){
    let _self = this;
    let model = {
        fromDate: this.startDate,
        toDate: this.endDate,
        type: "PERSONAL",
        programId: this.programId
    }

    AdminApiService.getUserTrainingOfTheDayForPeriod(model)
        .then((response) => {
            this.week.forEach(w => {w.details = [];})
            if(this.showType === 'MONTH'){
                response.data.forEach(dateObj => {
                    dateObj.playingVideo = null;
                    dateObj.showFullText = false;
                    dateObj.collapsed = false;
                    dateObj.results = [];
                    dateObj.choosedImage = null;
                    dateObj.choosedImagePreview = null;
                    if(dateObj.resultRounds != null && dateObj.resultRounds > 0){
                        for (var i = 0; i < dateObj.resultRounds; i++){
                            dateObj.results.push({
                                index: (i + 1),
                                id: null,
                                quantity: null,
                                weight: null
                            })
                        }
                    }
                    dateObj.isLoadingResults = dateObj.resultRounds != null || dateObj.resultMeasure;
                    const item = this.week.find(entry => entry.id === 0);
                    if (item) {
                        item.details.push(dateObj);
                    }
                });
            }else{
                response.data.forEach(dateObj => {
                    dateObj.playingVideo = null;
                    dateObj.showFullText = false;
                    dateObj.collapsed = false;
                    dateObj.results = [];
                    dateObj.choosedImage = null;
                    dateObj.choosedImagePreview = null;
                    if(dateObj.resultRounds != null && dateObj.resultRounds > 0){
                        for (var i = 0; i < dateObj.resultRounds; i++){
                            dateObj.results.push({
                                index: (i + 1),
                                id: null,
                                quantity: null,
                                weight: null
                            })
                        }
                    }
                    dateObj.isLoadingResults = dateObj.resultRounds != null || dateObj.resultMeasure;
                    const item = this.week.find(entry => entry.date === dateObj.date);
                    if (item) {
                        item.details.push(dateObj);
                    }
                });
            }
            _self.isLoading = false
            _self.getTrainingResultsForTrainingOfTheDays(response.data);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingResultsForTrainingOfTheDays(allItems){
    let _self = this;
    const ids = allItems.map(o => o.id);
    if(ids == null || ids.length <= 0) return;
    AdminApiService.getTrainingResultsForTrainingOfTheDays(ids)
        .then((response) => {
            //set loading false for results
            _self.week.forEach(w => {w.details.forEach(d => {
                d.isLoadingResults = false;
                let results = response.data[d.id]
                if(results != null){
                    d.collapsed = true;
                    d.results = []
                    var round = 1;
                    results.forEach( result => {
                        d.results.push({
                            index: round,
                            id: result.id,
                            quantity: result.quantity,
                            weight: result.weight,
                            userImage: result.userImage
                        })
                        round++;
                    })
                }
            })})
            //TODO dodaj logiku da se popune rezultati ako postoje

        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function deleteTrainingOfTheDay(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_training_of_the_day"),
        text: LocService.t("label_delete_training_of_the_day_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTrainingOfTheDay(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_training_of_the_day_successfully'), 'success')
                _self.getTrainingOfTheDayForPeriod();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })

    })
}

function getDayFromDate(dateString){
    const [day, month, year] = dateString.split("-");
    const date = new Date(year, month - 1, day);

// Dobij dan u sedmici (0 je nedelja, 1 je ponedeljak, itd.)
    const dayOfWeek = date.getDay();

    switch (dayOfWeek) {
        case 1:
            return LocService.t('day_monday')
        case 2:
            return LocService.t('day_tuesday')
        case 3:
            return LocService.t('day_wednesday')
        case 4:
            return LocService.t('day_thursday')
        case 5:
            return LocService.t('day_friday')
        case 6:
            return LocService.t('day_saturday')
        case 0:
            return LocService.t('day_sunday')
    }
}


function getMonthDisplay(month) {
    switch (month) {
        case 1: return this.locale.t("month_january");
        case 2: return this.locale.t("month_february");
        case 3: return this.locale.t("month_march");
        case 4: return this.locale.t("month_april");
        case 5: return this.locale.t("month_may");
        case 6: return this.locale.t("month_june");
        case 7: return this.locale.t("month_july");
        case 8: return this.locale.t("month_august");
        case 9: return this.locale.t("month_september");
        case 10: return this.locale.t("month_october");
        case 11: return this.locale.t("month_november");
        case 12: return this.locale.t("month_december");
        default: return this.locale.t("month_january");
    }
}

function isEnableFuture(){
    if(this.enableFuture === -2) return true
    return this.isWithinXMonthsAhead(this.currentDate)
}

function isWithinXMonthsAhead(date) {
    const xMonthsAhead = new Date();
    const currentMonth = xMonthsAhead.getMonth() + this.enableFuture;
    xMonthsAhead.setMonth(currentMonth);
    return date <= xMonthsAhead;
}

function saveResults(detailsItem){
    let _self = this;
    var model = {
        data: []
    }
    var roundIndex = 1;
    detailsItem.results.forEach(i => {
       let modelItem = {
           id: i.id,
           type: "PERSONAL",
           measure: detailsItem.resultMeasure,
           quantity: i.quantity,
           weight: i.weight,
           round: roundIndex,
           trainingOfTheDayId: detailsItem.id
       }
       model.data.push(modelItem)
       roundIndex++;
    });
    detailsItem.isLoadingResults = true;
    AdminApiService.saveTrainingResultsForTrainingOfTheDays(model)
        .then((response) => {
            detailsItem.isLoadingResults = false;
            detailsItem.collapsed = true;
            // _self.getTrainingResultsForTrainingOfTheDays()
        })
        .catch(error => {
            detailsItem.isLoadingResults = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

}

function uploadImageBeforeSaveResults(detailsItem) {
    let _self = this;
    detailsItem.isLoadingResults = true;
    AdminApiService.uploadTrainingImageResult(detailsItem.choosedImage)
        .then((response) => {
            _self.saveImageResults(detailsItem, response.data.url);
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function saveImageResults(detailsItem, url){
    let _self = this;
    var model = {
        data: []
    }
    var roundIndex = 1;
    detailsItem.results.forEach(i => {
        let modelItem = {
            id: i.id,
            type: "PERSONAL",
            measure: detailsItem.resultMeasure,
            quantity: 1,
            weight: 1,
            round: roundIndex,
            trainingOfTheDayId: detailsItem.id,
            userImage: url
        }
        model.data.push(modelItem)
        roundIndex++;
    });
    detailsItem.isLoadingResults = true;
    AdminApiService.saveTrainingResultsForTrainingOfTheDays(model)
        .then((response) => {
            _self.removeImage(detailsItem)
            detailsItem.isLoadingResults = false;
            detailsItem.collapsed = true;
            detailsItem.results[0].userImage = url;
            // _self.getTrainingResultsForTrainingOfTheDays()
        })
        .catch(error => {
            detailsItem.isLoadingResults = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

}

function isAllResultSet(detailsItem){
    var isEnable = true;
    detailsItem.results.forEach(i => {
        if(i.quantity == null || i.quantity.length === 0
            || i.weight == null || i.weight.length === 0) {
            isEnable = false;
        }
    });
    return isEnable;
}

function updateCollapsed(detailsItem){
    if(detailsItem.collapsed === true){
        detailsItem.collapsed = false
    }else{
        detailsItem.collapsed = true
    }
}



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalUserDetailsProgram.js